<template>
  <RF-Dialog
  :cpntLargura='"420px"'
  :cpntTitulo="'Baixar o programa para Suporte Remoto?'"
  :cpntStatus="statusGeral"
  :cpntOnFecharDialog='subaseSupFechar'>
  <template slot='conteudo'>
    <div class="sub-sup-rem">
      <div class="windows" v-if="plataforma !== 'macOS'">
        <div class="titulo">
          Aplicativo para Windows
          <svg class="fab fa-windows"></svg>
        </div>

        <div class="conteudo">
          <App-Button @onClick="() => { subaseSupOnClick('anydesk') }">
            <img src="/img/geral/anydesk.png">
          </App-Button>

          <App-Button @onClick="() => { subaseSupOnClick('teamviewer') }">
            <img src="/img/geral/teamviewer.png">
          </App-Button>
        </div>
      </div>

      <!-- <hr /> -->

      <div class="mac" v-else>
        <div class="titulo">
          Aplicativo para macOS
          <svg class="fab fa-apple"></svg>
        </div>

        <div class="conteudo">
          <App-Button @onClick="() => { subaseSupOnClick('anydesk') }">
            <img src="/img/geral/anydesk.png">
          </App-Button>

          <!-- <App-Button @onClick="() => { subaseSupOnClick('teamviewer') }">
            <img src="/img/geral/teamviewer.png">
          </App-Button> -->
        </div>
      </div>
    </div>
  </template>
  </RF-Dialog>
</template>

<style scoped>
  .sub-sup-rem {
    padding-top: 10px;
    text-align: center;
  }
    .sub-sup-rem > hr {
      margin: 20px 0px 10px 0px;

    }
    .sub-sup-rem > div > .titulo {
      font-weight: bold;
      font-size: 20px;
    }
      .sub-sup-rem > .windows > .titulo > svg {
        font-size: 30px;
        vertical-align: -9px;
      }
      .sub-sup-rem > .mac > .titulo > svg {
        font-size: 30px;
        vertical-align: -4px;
      }

    .sub-sup-rem > div > .conteudo {
      text-align: center;
    }
      .sub-sup-rem > div > .conteudo > button {
        margin: 10px;
        height: 60px;
      }
      .sub-sup-rem > div > .conteudo > button > img {
        width: 150px;
      }
</style>

<script>
  export default {
    props: {
      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        plataforma: ''
      }
    },
    mounted: function () {
      this.subaseSupIniciar()
    },
    methods: {
      subaseSupIniciar: function () {
        this.plataforma = [ '', null, undefined ].indexOf(navigator.platform) === -1 ? navigator.platform : navigator.userAgentData.platform
      },
      subaseSupOnClick: function (app) {
        switch (this.plataforma + '__' + app) {       
          case 'macOS__anydesk':
            window.open('https://anydesk.com/pt/downloads/thank-you?dv=mac_dmg3', '_blank')
            break

          case 'Win32__anydesk':
          case 'Win86__anydesk':
          case 'Win64__anydesk':
          case 'Windows__anydesk':
            window.open('https://anydesk.com/pt/downloads/thank-you?dv=win_exe', '_blank')
            break

          case 'Win32__teamviewer':
          case 'Win86__teamviewer':
          case 'Win64__teamviewer':
          case 'Windows__teamviewer':
          default:
            window.open('https://s3-sa-east-1.amazonaws.com/arq.rotinafacil.com/suporte/TeamViewerQS.exe', '_blank')
            break
        }
      },
      subaseSupFechar: function () {
        this.cpntFecharFormulario()
      }
    }
  }
</script>
